import styled from 'styled-components'
import { Subtitle } from '../styles'

export const Container = styled.div`
  padding-right: 15px;
`

export const SubtitleToLogin = styled(Subtitle)`
  text-align: center;
`
export const ButtonContainer = styled.div`
  margin-top: 6px;
`
